import { z } from 'zod';

export const getRelatedArticlesSchema = z.array(z.object({
	id: z.number(),
	zenDeskId: z.number(),
	url: z.string(),
	sectionId: z.number(),
	name: z.string(),
	title: z.string().nullable(),
	editedAt: z.string().datetime({ local: true }),
	body: z.string().nullable(),
}));